<div class="wrapper">
  <div class="statuses-container hide-mobile">
    @for (count of countsByRating.value(); track count) {
      <div
        class="status-box"
        (click)="toggleRatingFilter(count.rating)"
      >
        <div class="status-content">
          <div class="checkbox-container" >
            @if (ratingOn(count.rating)) {
              <mat-icon >check_box</mat-icon>
            }@else{
              <mat-icon class="default">check_box_outline_blank</mat-icon>
              <mat-icon class="on-hover">check_box_outline_blank</mat-icon>
            }
          </div>
          @if (countsByRating.isLoading()) {
            <mat-progress-spinner mode="indeterminate" [diameter]="20"></mat-progress-spinner>
          }
          @else {
            
            <div class="counter">
              <span class="default">{{count?.count ?? 0}}</span>
              <span class="on-hover">{{getPercentageForCount(count?.count)}}%</span>
            </div>
            <div class="status-name">
              <app-stars [stars]="count.rating"></app-stars>
            </div>
          }
          
        </div>
      </div>
    }
  </div>


  <div class="search-container">
    <div class="search-bar" >
      @if (searchControl.value) {
        <button mat-icon-button (click)="clearSearch()"> <mat-icon>arrow_back</mat-icon> </button>
      }
      @else {
        <mat-icon class="icon-container">search</mat-icon>
      }
      <input [formControl]="searchControl" name="search_query" autocomplete="off" autocorrect="off" spellcheck="false">
    </div>
  </div>

  <div class="table-container display-desktop" id="clients" >
    <mat-card class="box-shadowless">
      <mat-card-content style="padding: 0;">
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)">

          <ng-container matColumnDef="rut">
            <th mat-header-cell *matHeaderCellDef> {{ 'client_identifier' | human }} </th>
            <td mat-cell *matCellDef="let client"> {{ client.rut | identifier }} </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'client' | human }} </th>
            <td mat-cell *matCellDef="let client"> {{ client.name | titlecase }} </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef> <i class="fa fa-envelope"></i> &nbsp; Email </th>
            <td mat-cell *matCellDef="let client"> {{ client.email | lowercase }} </td>
          </ng-container>

          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef> {{ 'phone' | human }} </th>
            <td mat-cell *matCellDef="let client"> {{ client.phone }} </td>
          </ng-container>

          <ng-container matColumnDef="last_order_date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Última visita </th>
            <td mat-cell *matCellDef="let client"> {{ client.last_order_date | date }} </td>
          </ng-container>

          <ng-container matColumnDef="rating">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Categoría</th>
            <td mat-cell *matCellDef="let client">
              <app-stars [stars]="client.rating"></app-stars>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          @if (!isLoading()) {
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" go-to-details [element]="{id: row.id, type: 'Client'}"></tr>
          }
        </table>

        @if (isLoading()) {
          <div class="empty">
            <mat-spinner></mat-spinner>
          </div>
        }
        
        @if (clients() && clients().length === 0) {
          <div class="empty white-rounded">
            <span>No se han encontrado {{ 'client_plural' | human }}</span>
          </div>
        }

        @if (isLoading()) {
          <div class="load-more white-rounded">
            <mat-spinner [diameter]="20"></mat-spinner> Cargando {{'client' | human: null: null: 'plural'}}...
          </div>
        }

        <mat-paginator
          #paginator
          [length]="totalData"
          [pageSizeOptions]="pageSizes"
          showFirstLastButtons>
        </mat-paginator>

      </mat-card-content>
    </mat-card>
  </div>
  <div class="table-container display-mobile scroll-shadows" id="clients" appPagination (loadMore)="getMore()" [isLoading]="isLoading()" [page]="page" [totalPages]="totalPages">
    <div class="card" *ngFor="let client of clients()" [routerLink]="['/main', 'crm', 'clients', client.id]">
      <div class="card-details">
        <div class="row">
          <span class="light"> {{'client_identifier' | human}}:&nbsp;{{client.rut | identifier}}</span>
          <div class="expander"></div>
          <app-stars [stars]="client.rating"></app-stars>
        </div>
        <div class="row title">
          <span class="bold">{{client.name}}</span>
  
        </div>
        <div class="row">
          <span>{{client.email}} </span>
        </div>
      </div>
    </div>
  
    @if (clients() && clients().length === 0 && !isLoading()) {
      <div class="empty">
        <span>No se han encontrado {{ 'client_plural' | human }}</span>
      </div>
    }

    <div class="load-more" [hidden]="page >= totalPages" id="load-more">
      <mat-spinner [diameter]="20"></mat-spinner> Cargando {{'client_plural' | human: 'lowercase'}}...
    </div>
  
    @if (isLoading()) {
      <div class="loading">
        <mat-spinner></mat-spinner>
      </div>
    }
  </div>
</div>

